/**
 * Handle page-level tableau filtering and all filtering related elements
 */
window.onload = function () {
    /**
     * Filter tableau figures by vehicle, fuel pathway, year. This is used for
     * both the individual vehicle techs and the comparison page
     */
    const parameterAction = function (event) {
        const param = event.target.attributes.param.value;
        const value = event.target.value;

        for (let viz of window.tableau_vizs) {
            // Change fuel pathway
            if ( param === "Fuel Pathway Base_cost_CO2 Parameter" && (
                    viz.url.includes('2021LCOD')
                    || viz.url.includes('2021Emissions')
                    || viz.url.includes('2021COMPLCOD')
                    || viz.url.includes('2021COMPEmissions')
                    || viz.url.includes('2021COMPSingleYearLCOD')
                    || viz.url.includes('2021COMPSingleYearEmissions')
            ) ) {
                viz.getWorkbook().changeParameterValueAsync(param, value);
                continue;
            }

            // Change year
            if ( param === 'Year_str Parameter' && viz.url.includes('2021COMPSingleYear') ) {
                viz.getWorkbook().changeParameterValueAsync(param, value);
                continue;
            }

            // Change vehicle powertrain tech
            if ( param === 'Veh_name' ) {
                const values = [];
                for (let box of $('input[param=Veh_name]')) {
                    if (box.checked) {
                        values.push(box.value);
                    }
                }

                if (values.length === 0) {
                    alert ('Please select at least one vehicle technology');
                    return;
                }

                const sheet = viz.getWorkbook().getActiveSheet().getWorksheets()[0];
                sheet.applyFilterAsync('Veh name', values, tableau.FilterUpdateType.REPLACE);
                continue;
            }
        }
    };

    /**
     * Add event listeners to create collapsible panels
     * @param {DOM Elements} elems
     */
    const handleCollapsiblePanel = function (elems) {
        // Add event handlers to vehicle panels (left nav bar)
        elems.each(function () {
            $(this).on('click', function () {
                $(this).toggleClass('filter-active');
                var panel = $($(this)[0]).next().children()[0];

                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = (panel.scrollHeight + 200) + "px";
                }
            });
        });

        // Open all default filterPanels
        elems.each(function () {
            if ($(this).parent().hasClass('atbDefaultOpen')) $(this).click();
        });
    };

    /*** ADD LISTENERS **/
    $('.atbDataFilter').on('click', '.atbFilterOption > label > input', parameterAction );

	$('#showHideFilters').on('click', function() {
		var panelClosed = $('#showHideFilters')[0].style['right'] === '-30px';
        $(this)[0].style.setProperty('right', panelClosed ? '215px' : '-30px');
		$('#atbInnerRightColumn').toggleClass('panel-open');
	});
    handleCollapsiblePanel($('.atbDataFilterBlock h3'));

    $('#showHideFilters').removeClass('d-none');
};